/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { Action } from '../../../../components/ActionsCard/ActionCard';
import { strings } from '../../../../intl/Strings';
import { LftSidePaneActionId } from '../shared';

export const LftSidePaneWhatCanIDoAction = (onClickHandler?: () => void): Action => ({
    id: LftSidePaneActionId.WhatCanIDo,
    checked: false,
    primaryContent: strings.getString('lftSidePaneCopilotTitle'),
    secondaryContent: strings.getString('lftSidePaneCopilotContent'),
    onClick: () => {
        onClickHandler?.();
    }
});
